﻿import { fromEvent, map } from "rxjs";

export default class NameInput {
  constructor() {
    this.valueInput = '';
    this.errorMessageId = 'nhs_ErrorForName';
    this.id = 'Name';
    this.errorCssClass = 'error';
    this.errorMessage = `<span id="${this.errorMessageId}" class="form__error" hidden>
                           Please fill in your first and last name
                         </span>`;
    this.label = `<label for="${this.id}" class="visuallyhidden">Full Name</label>`;
    this.pattern = `^([A-Za-zà-ü]+(-?'?[A-Za-z+'?-?à-ü]+))(\\s([A-Za-zà-ü]+(-?'?[A-Za-z+'?-?à-ü]+)?))+?$`;
    this.matchingPattern = new RegExp(this.pattern);
  }

  set value(newValue){
    this.valueInput = newValue || '';
  }

  get value(){
    return this.valueInput;
  }

  getHtml() {
    return `${this.label}<input data-qa="name-input" data-segment-identity-data="Name" id="${this.id}" class="form__input" 
            placeholder="*First and Last Name" maxlength="100" name="name" autocomplete="name" 
            type="text" required value="${this.value}"></input>${this.errorMessage}`;
  }

  getNode() {
    return document.getElementById(this.id);
  }

  /**
   * getOnChangeEvent: On input change map its value to the storage property.
   */
  getOnChangeEvent() {
    return fromEvent(this.getNode(), 'change').pipe(
      map((event) => ({name: event.target.value}))
    );
  }

  setInvalidState(node) {
    const errorMessage = document.getElementById(this.errorMessageId);

    node.setAttribute('aria-invalid', true);
    node.classList.add(this.errorCssClass);
    errorMessage.removeAttribute('hidden');
  }

  setValidState(node) {
    const errorMessage = document.getElementById(this.errorMessageId);

    node.removeAttribute('aria-invalid');
    node.classList.remove(this.errorCssClass);
    errorMessage.setAttribute('hidden', true);
  }

  focus() {
    const nameInput = this.getNode();
    nameInput.focus();
  }

  validate() {
    const node = this.getNode();

    /* NHS20-1684: we verify that the value taken from the input it's clean,
    in case of spaces before and after the text, also is updated in the UI. */
    const cleanedValue = node.value.trim().replace(/\s+/g, ' ');
    node.value = cleanedValue;
    const isValid = this.matchingPattern.test(cleanedValue);

    if (isValid) {
      this.setValidState(node);
    } else {
      this.setInvalidState(node);
    }

    return isValid;
  }
}
